import { useState } from "react";
import { Spinner } from "react-bootstrap";
import ModalCloseIcon from "../../../Assets/svg/close-modal.svg";
import ticketLogo from "../../../Assets/svg/ticket_icon.svg";
import { apiCall } from "../../../services/api-service.js";

const AddCommentModal = ({ ticketDetail, onHide, onSuccess }) => {
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (!comment.trim()) {
      setError("Please enter a comment");
      return;
    }

    setLoading(true);
    try {
      const response = await apiCall("put", `ticket/add_comment/${ticketDetail.id}`, {
        comment: comment,
      });

      if (response?.data?.success) {
        onSuccess();
      } else {
        setError(response?.data?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Add Comment Error:", err);
      setError("An error occurred while adding the comment");
    } finally {
      setLoading(false);
    }
  };

  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      borderRadius: "24px",
      width: "520px",
      padding: "24px",
      boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
    },
  };

  return (
    <div style={modalStyle.overlay} onClick={onHide}>
      <div style={modalStyle.modal} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 style={{ fontSize: "24px", fontWeight: "700", color: "#212129", margin: 0 }}>Add Comment</h2>
          <div
            onClick={onHide}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              border: "1px solid #EBEBEB",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <img src={ModalCloseIcon} alt="close" style={{ width: "14px" }} />
          </div>
        </div>

        {/* Ticket Info Card */}
        <div
          style={{
            background: "#F7F8F9",
            borderRadius: "16px",
            padding: "16px",
            display: "flex",
            gap: "16px",
            alignItems: "flex-start",
            marginBottom: "24px",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              background: "#ffff",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <img src={ticketLogo} alt="ticket" style={{ width: "20px" }} />
          </div>
          <div style={{ overflow: "hidden" }}>
            <h3
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#212129",
                marginBottom: "4px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {ticketDetail.code} - {ticketDetail.title}
            </h3>
            <div className="d-flex align-items-center gap-2">
              <span style={{ fontSize: "14px", color: "#8790A1" }}>{ticketDetail.project || "No Project"}</span>
              <span style={{ width: "4px", height: "4px", background: "#D9D9D9", borderRadius: "50%" }}></span>
              <span style={{ fontSize: "14px", color: "#6929E2", fontWeight: "500" }}>{ticketDetail.status}</span>
            </div>
          </div>
        </div>

        {/* Form Fields */}
        <div className="mb-4">
          <label style={{ fontSize: "14px", fontWeight: "600", color: "#212129", marginBottom: "8px", display: "block" }}>
            Add comment <span style={{ color: "red" }}>*</span>
          </label>
          <textarea
            placeholder="Enter here..."
            className="form-control"
            rows={4}
            value={comment}
            onChange={(e) => {
              setComment(e.target.value);
              setError("");
            }}
            style={{
              borderRadius: "12px",
              border: "1px solid #EBEBEB",
              padding: "12px",
              fontSize: "14px",
              resize: "none",
            }}
          />
          {error && <span style={{ color: "#F44336", fontSize: "12px", marginTop: "4px", display: "block" }}>{error}</span>}
        </div>

        {/* Actions */}
        <div className="d-flex justify-content-end gap-3">
          <button
            onClick={onHide}
            style={{
              padding: "12px 32px",
              borderRadius: "100px",
              border: "1px solid #EBEBEB",
              background: "#FFFFFF",
              fontSize: "16px",
              fontWeight: "700",
              color: "#212129",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              padding: "12px 32px",
              borderRadius: "100px",
              border: "none",
              background: "#6929E2",
              fontSize: "16px",
              fontWeight: "700",
              color: "#FFFFFF",
              cursor: "pointer",
              minWidth: "120px",
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? <Spinner animation="border" size="sm" variant="light" /> : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCommentModal;
